// import { actionTypes } from "./actionTypex"
// demo img
// import img1 from "../images/products/p1.jpg";

// product-fashion-mens wear
import mp1 from "../images/products/mens/p1.png";
import mp2 from "../images/products/mens/p2.png";
import mp3 from "../images/products/mens/p3.png";
import mp4 from "../images/products/mens/p4.png";
import mp5 from "../images/products/mens/p5.png";
import mp6 from "../images/products/mens/p6.png";
import mp7 from "../images/products/mens/p7.png";
import mp8 from "../images/products/mens/p8.png";
import mp9 from "../images/products/mens/p9.png";
import mp10 from "../images/products/mens/p10.jpg";

// product fashsion girls wear

import gp1 from "../images/products/girls/p1.png";
import gp2 from "../images/products/girls/p2.png";
import gp3 from "../images/products/girls/p3.png";
import gp4 from "../images/products/girls/p4.jpg";
import gp5 from "../images/products/girls/p5.jpg";
import gp6 from "../images/products/girls/p6.jpg";
import gp7 from "../images/products/girls/p7.jpg";
import gp8 from "../images/products/girls/p8.jpg";
import gp9 from "../images/products/girls/p9.jpg";
import gp10 from "../images/products/girls/p10.png";

// product fashion kids wear

import k1 from "../images/products/kids/k1.jpg"
import k2 from "../images/products/kids/k2.jpg"
import k3 from "../images/products/kids/k3.jpg"
import k4 from "../images/products/kids/k4.jpg"
import k5 from "../images/products/kids/k5.jpg"
import k6 from "../images/products/kids/k6.jpg"
import k7 from "../images/products/kids/k7.jpg"
import k8 from "../images/products/kids/k8.jpg"
import k9 from "../images/products/kids/k9.jpg"
import k10 from "../images/products/kids/k10.jpeg"

// grocery

import g1 from "../images/products/grocery/g1.jpg";
import g2 from "../images/products/grocery/g2.jpg";
import g3 from "../images/products/grocery/g3.jpg";
import g4 from "../images/products/grocery/g4.jpg";
import g5 from "../images/products/grocery/g5.jpg";




const products = [{
    fashion: [
        {
            itemId: 1,
            itemTitle: "flying machine",
            itemPrice: 420,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp1,
        },
        {
            itemId: 2,
            itemTitle: "flying machine",
            itemPrice: 590,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp2,
        },
        {
            itemId: 3,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp3,
        },
        {
            itemId: 4,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp4,
        },
        {
            itemId: 5,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp5,
        },
        {
            itemId: 6,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp6,
        },
        {
            itemId: 7,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp7,
        },
        {
            itemId: 8,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp8,
        },
        {
            itemId: 9,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp9,
        },
        {
            itemId: 10,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: mp10,
        },
        // girls wear
        {
            itemId: 11,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp1,
        },
        {
            itemId: 12,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp2,
        },
        {
            itemId: 13,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp3,
        },
        {
            itemId: 14,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp4,
        },
        {
            itemId: 15,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp5,
        },
        {
            itemId: 16,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp6,
        },
        {
            itemId: 17,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp7,
        },
        {
            itemId: 18,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp8,
        },
        {
            itemId: 19,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp9,
        },
        {
            itemId: 20,
            itemTitle: "flying machine",
            itemPrice: 1050,
            itemDesc: "Some quick example text to build on the card title and make up the bulk of the card's content.",
            itemInfoDetailed: "detailed info of itme",
            img: gp10,
        },

        // kids wear

        {
            itemId: 21,
            itemTitle: "kids package",
            itemPrice: 2350,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k1,
        },
        {
            itemId: 22,
            itemTitle: "printed black",
            itemPrice: 2350,
            itemDesc: "cool black shirt with prints, in this item a black goggle is free, be smart buy smart",
            itemInfoDetailed: "detailed info of itme",
            img: k2,
        },
        {
            itemId: 23,
            itemTitle: "Doll skirt",
            itemPrice: 2350,
            itemDesc: "Doll skirt,one t-shirt one skirt, one top, one cafree, buy all in one.",
            itemInfoDetailed: "detailed info of itme",
            img: k3,
        },
        {
            itemId: 24,
            itemTitle: "four in one",
            itemPrice: 2350,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k4,
        },
        {
            itemId: 25,
            itemTitle: "Lay Opel",
            itemPrice: 2350,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k5,
        },
        {
            itemId: 26,
            itemTitle: "Adidas",
            itemPrice: 1150,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k6,
        },
        {
            itemId: 27,
            itemTitle: "Adidas",
            itemPrice: 1410,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k7,
        },
        {
            itemId: 28,
            itemTitle: "Levi's",
            itemPrice: 3299,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k8,
        },
        {
            itemId: 29,
            itemTitle: "Allen Solly",
            itemPrice: 5399,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k9,
        },
        {
            itemId: 30,
            itemTitle: "Prada",
            itemPrice: 9459,
            itemDesc: "Buy this amazing package with 3 diffrent set of cloths, smart package for smart kids.",
            itemInfoDetailed: "detailed info of itme",
            img: k10,
        },


    ],
    electronix: [],
    grocery: [

        {
            itemId: 1,
            itemTitle: "Fruits",
            itemPrice: 459,
            itemDesc: "Shop from a wide range of fresh, organic and exotic fruits online. Select a slot for delivery.",
            itemInfoDetailed: "detailed info of itme",
            img: g1,
        },
        {
            itemId: 2,
            itemTitle: "Fruits",
            itemPrice: 459,
            itemDesc: "Shop from a wide range of fresh, organic and exotic fruits online. Select a slot for delivery.",
            itemInfoDetailed: "detailed info of itme",
            img: g2,
        },
        {
            itemId: 3,
            itemTitle: "Healthy for kids",
            itemPrice: 459,
            itemDesc: "Shop from a wide range of fresh, organic and exotic fruits online. Select a slot for delivery.",
            itemInfoDetailed: "detailed info of itme",
            img: g3,
        },
        {
            itemId: 4,
            itemTitle: "Soap and detergent",
            itemPrice: 459,
            itemDesc: "Shop from a wide range of fresh, organic and exotic fruits online. Select a slot for delivery.",
            itemInfoDetailed: "detailed info of itme",
            img: g4,
        },
        {
            itemId: 5,
            itemTitle: "Fruits with vegetable",
            itemPrice: 459,
            itemDesc: "Shop from a wide range of fresh, organic and exotic fruits online. Select a slot for delivery.",
            itemInfoDetailed: "detailed info of itme",
            img: g5,
        },
    ],
    mobile: [],
}
];

const productReducer = (state = products, action) => {
    switch (action.type) {
        default: return state;
    }

}

export default productReducer;
































// { mens: [] },
    //     { girls: [] },
    //     { kids: [] },
    //     { kids: [] },

    // fashion, electronix, grocery, mobile
